export * from './agenda';
export * from './consigna-detail';
export * from './new-consigna-dialog';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agenda/index.ts